// --------------------------------------------------------------------------
// ticketType.js
// --------------------------------------------------------------------------
// Toggles a class on ticket type wrapper depending on checked / unchecked
// --------------------------------------------------------------------------

RN.ticketType = function() {

  'use strict';

  function init() {
    byBehaviour('ticket-type').on('change', toggleSelected);
  }

  function toggleSelected() {
    $(this).closest('.ticket-type').addClass('ticket-type--is-selected').siblings().removeClass('ticket-type--is-selected');
  }

  return {
    init: init
  };

}();